import { useQuery } from '@tanstack/react-query';

import { tariffPricingQueryOptions } from '../data-provider';

export const useTariffPricing = (tariffKey: number, options?: { enabled?: boolean }) =>
  useQuery({
    ...tariffPricingQueryOptions(tariffKey),
    enabled: options?.enabled ?? true,
  });
